import 'minireset.css';
import { ThemeProvider } from '@snapp/ui-kit';
import ErrorBoundary from './components/errors/error-boundary/error-boundary';
import { getCurrentLocale } from './i18n';
import Router from './router';

const fallbackFonts = `
-apple-system,
    BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif
`;

function App() {
  const { language, direction } = getCurrentLocale();
  const font =
    language === process.env.REACT_APP_DEFAULT_LANGUAGE
      ? 'PrimaryLang'
      : 'SecondaryLang';

  const fontFamily = `${font}, ${fallbackFonts}`;

  return (
    <ErrorBoundary>
      <main style={{ fontFamily, direction }}>
        <ThemeProvider
          id="rootThemeProvider"
          direction={direction}
          defaultIconsDirection={direction}
          defaultCDN={process.env.REACT_APP_CDN}
          cacheIcon="enable"
          colors={{
            primary: process.env.REACT_APP_COLOR_PRIMARY,
            primary2: process.env.REACT_APP_COLOR_PRIMARY2,
            lightGray: '#f2f2f2',
            ems: '#f0543c',
            sos: '#008efa',
            club: '#ffdd00',
          }}
        >
          <Router />
        </ThemeProvider>
      </main>
    </ErrorBoundary>
  );
}

export default App;
